import { IAddPublicationShipmentRequest } from "../../../../model/publication-shipment/request/add-publication-shipment-request";
import { IPublishingVehicleResponse as IListVeiculoPublicacaoResponse } from "../../../../model/publication-shipment/response/publising-vehicle-response";


export type EnvioRemessaState = {
  addPublicationShipmentRequest: IAddPublicationShipmentRequest;
  fieldIsValid?: boolean;
  loading?: boolean;
  listPublishingVehicleResponse?: IListVeiculoPublicacaoResponse[];
  files: File[];
};

export enum ACTION_TYPES {
  setAddPublicationShipmentRequest = 'setAddPublicationShipmentRequest',
  setFieldIsValid = 'setFieldIsValid',
  setLoading = 'setLoading',
  setFiles = 'setFiles',
  setListPublishingVehicleResponse = 'setListPublishingVehicleResponse',
}

export const EnvioRemessaReducer = (state: EnvioRemessaState, action: any): EnvioRemessaState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setAddPublicationShipmentRequest:
      return {
        ...state,
        addPublicationShipmentRequest: payload,
      };
    case ACTION_TYPES.setFiles:
      return {
        ...state,
        files: payload,
      };
    case ACTION_TYPES.setFieldIsValid:
      return {
        ...state,
        fieldIsValid: payload,
      };
    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: payload,
      };
    case ACTION_TYPES.setListPublishingVehicleResponse:
      return {
        ...state,
        listPublishingVehicleResponse: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}